import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import brandPortalCustomers from "@faire/web-api/routes/brand-portal/customers";
import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import { path as getSelfServeRecommendedArticleRoute } from "@faire/web-api/routes/support/self-serve/recommended-article";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var QuestionAboutCustomerIA = function QuestionAboutCustomerIA(_ref) {
  var _selectedBrandOrder$b, _selectedBrandOrder$b2, _selectedBrandOrder$r;
  var context = _ref.context;
  var selectedBrandOrder = context.brandOrder;
  var brandOrderToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : (_selectedBrandOrder$b = selectedBrandOrder.brand_order) === null || _selectedBrandOrder$b === void 0 ? void 0 : _selectedBrandOrder$b.token;
  var brandName = (_selectedBrandOrder$b2 = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_name) !== null && _selectedBrandOrder$b2 !== void 0 ? _selectedBrandOrder$b2 : "brand";
  var retailerName = (_selectedBrandOrder$r = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.retailer_name) !== null && _selectedBrandOrder$r !== void 0 ? _selectedBrandOrder$r : "retailer";
  var conversationName = isBrand() ? retailerName : brandName;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "T44xRB",
      defaultMessage: [{
        "type": 0,
        "value": "Ga voor meer informatie over een klant die een bestelling heeft geplaatst naar de "
      }, {
        "children": [{
          "type": 0,
          "value": "bestellingspagina"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": ". Op deze pagina worden de naam, het telefoonnummer en het adres van de retailer weergegeven. Voor meer informatie kun je op de naam van de retailer klikken om naar de pagina van de retailer te gaan op het tabblad "
      }, {
        "children": [{
          "type": 0,
          "value": "Klanten"
        }],
        "type": 8,
        "value": "CustomerLinkFormatting"
      }, {
        "type": 0,
        "value": ". De klantpagina bevat:"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return orderDetailsLinkFormatting(chunks);
        },
        CustomerLinkFormatting: function CustomerLinkFormatting(chunks) {
          return customersLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "H0tQBp",
      defaultMessage: [{
        "type": 0,
        "value": "Eerdere bestellingen"
      }]
    }))), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "PQSolo",
      defaultMessage: [{
        "type": 0,
        "value": "Totaal bestelvolume"
      }]
    }))), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "rFfKGc",
      defaultMessage: [{
        "type": 0,
        "value": "Type relatie"
      }]
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Yl6Vqu",
      defaultMessage: [{
        "type": 0,
        "value": "Meer informatie, waaronder wanneer de retailer zich heeft geregistreerd op Faire"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gPsfr6",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt de retailer ook rechtstreeks een bericht sturen vanaf de pagina van de klant door op de knop "
      }, {
        "children": [{
          "type": 1,
          "value": "conversationCompanyName"
        }, {
          "type": 0,
          "value": " een bericht sturen"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " te klikken als je hem of haar een vraag wilt stellen."
      }],
      values: {
        conversationCompanyName: conversationName,
        LinkFormatting: function LinkFormatting(chunks) {
          return messageLinkFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "4b7lCJ",
      defaultMessage: [{
        "type": 0,
        "value": "Ga voor meer informatie over een klant die een bestelling heeft geplaatst naar je "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestellingen"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " en navigeer naar een specifieke bestelling. Op de bestellingspagina worden de naam, het telefoonnummer en het adres van de retailer weergegeven. Voor meer informatie kun je op de naam van de retailer klikken om naar de pagina van de retailer te gaan op het tabblad "
      }, {
        "children": [{
          "type": 0,
          "value": "Klanten"
        }],
        "type": 8,
        "value": "CustomerLinkFormatting"
      }, {
        "type": 0,
        "value": ". De klantpagina bevat:"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return orderDetailsLinkFormatting(chunks);
        },
        CustomerLinkFormatting: function CustomerLinkFormatting(chunks) {
          return customersLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "H0tQBp",
      defaultMessage: [{
        "type": 0,
        "value": "Eerdere bestellingen"
      }]
    }))), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "PQSolo",
      defaultMessage: [{
        "type": 0,
        "value": "Totaal bestelvolume"
      }]
    }))), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "rFfKGc",
      defaultMessage: [{
        "type": 0,
        "value": "Type relatie"
      }]
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Yl6Vqu",
      defaultMessage: [{
        "type": 0,
        "value": "Meer informatie, waaronder wanneer de retailer zich heeft geregistreerd op Faire"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gPsfr6",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt de retailer ook rechtstreeks een bericht sturen vanaf de pagina van de klant door op de knop "
      }, {
        "children": [{
          "type": 1,
          "value": "conversationCompanyName"
        }, {
          "type": 0,
          "value": " een bericht sturen"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " te klikken als je hem of haar een vraag wilt stellen."
      }],
      values: {
        conversationCompanyName: conversationName,
        LinkFormatting: function LinkFormatting(chunks) {
          return messageLinkFormatting(chunks);
        }
      }
    })));
  }
};
var messageLinkFormatting = function messageLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: getSelfServeRecommendedArticleRoute({
      message_modal: "1"
    })
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var orderDetailsLinkFormatting = function orderDetailsLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var customersLinkFormatting = function customersLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalCustomers(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var isBrand = function isBrand() {
  var retailerToken = getRetailerToken();
  if (retailerToken) {
    return false;
  }
  return true;
};